exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".term-section .term-section-title {\n  font-weight: bold; }\n", ""]);

// exports
